var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
const SvgWatchedCheck = (_ref, svgRef) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58.723,
    height: 13.32,
    viewBox: "0 0 58.723 13.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.707 -1.68)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(18.016 12)",
    fill: "#fff",
    fontSize: 12,
    fontFamily: "MarkPro-Heavy, Mark Pro",
    fontWeight: 800,
    letterSpacing: "0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "VISTO")), /*#__PURE__*/React.createElement("path", {
    d: "M2924.453,1620.841l4.3,4.3,9.651-9.651",
    transform: "translate(-2924.453 -1613.104)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatchedCheck);
export default __webpack_public_path__ + "static/media/watched-check.8c4b288f485a712e5340c5e3f264bb56.svg";
export { ForwardRef as ReactComponent };